import React from "react";
import NavbarSix from "../components/NavbarSix";
import BannerSeven from "../components/BannerSeven";
import AboutAreaEight from "../components/AboutAreaEight";
import CategoryBrowserOne from "../components/CategoryBrowserOne";
import CollectiblesOne from "../components/CollectiblesOne";
import ProjectAreaTwo from "../components/ProjectAreaTwo";
import SellerOne from "../components/SellerOne";
import FaqAreaThree from "../components/FaqAreaThree";
import WorkProcessSix from "../components/WorkProcessSix";
import TestimonialSix from "../components/TestimonialSix";
import CreatorOne from "../components/CreatorOne";
import BlogAreaSeven from "../components/BlogAreaSeven";
import FooterSix from "../components/FooterSix";

const HomeSix = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavbarSix />

      {/* Banner Seven */}
      <BannerSeven />

      {/* About Area Eight */}
      <AboutAreaEight />

      {/* Category Browser One */}
      <CategoryBrowserOne />

      {/* Collectibles One */}
      <CollectiblesOne />

      {/* Project Area Two */}
      <ProjectAreaTwo />

      {/* Seller One */}
      <SellerOne />

      {/* Faq Area Three */}
      <FaqAreaThree />

      {/* Work Process Six */}
      <WorkProcessSix />

      {/* Testimonial Six */}
      <TestimonialSix />

      {/* Creator One */}
      <CreatorOne />

      {/* Blog Area Seven */}
      <BlogAreaSeven />

      {/* Footer Six */}
      <FooterSix />
    </>
  );
};

export default HomeSix;
